import React, { useState, useEffect, useRef } from "react";
import { Space, Switch, Table } from "antd";
import Navbar from "modules/Navbar/Navbar";
import SideBar from "modules/SideBar/SideBar";
import Header from "modules/SubComponents/Header";
import { Container } from "react-bootstrap";
import {
  changePackageStatus,
  deletePackage,
  editPackage,
  getAllPackages,
} from "Network";
import { toastError, toastSuccess } from "helpers/toasters";
import SubHeader from "modules/SubComponents/SubHeader";
import DeleteModal from "modules/Modals/DeleteModal";
import warrningIcon from "assets/icons/warning.svg";
import { useSelector } from "react-redux";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AddEditPackageModal from "./AddEditPackageModal";
import DeletePackageModal from "./DeletePackageModal";

const Subscriptions = () => {
  const [loadingTable, setLoadingTable] = useState(true);
  const [loadingEditModal, setLoadingEditModal] = useState(false);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [renderMe, setRenderMe] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [deletePackageModal, setDeletePackageModal] = useState(false);
  const modalRef = useRef();

  const {
    authorization: { isCeo, isCodesManager },
  } = useSelector((state) => state?.auth);

  useEffect(() => {
    getAllPackages(
      (success) => {
        if (success?.isSuccess) {
          setDataSource(success.data);
          setLoadingTable(false);
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      }
    );
  }, [renderMe]);

  const showDeleteModal = (record) => {
    setSelectedRowData(record);
    setDeleteModalVisible(true);
  };

  const onCancel = () => {
    setAddModalVisible(false);
    setDeleteModalVisible(false);
    setSelectedPackage(null);
    setRenderMe((prev) => !prev);
  };

  const handleAddEditPackage = () => {
    setAddModalVisible(true);
  };

  const handleCancelDeletePackageModal = () => {
    setDeletePackageModal(false);
  };

  const baseColumns = [
    // PACKAGE NAME
    { title: "PACKAGE NAME", key: "packageName", dataIndex: "packageName" },
    // MONTHLY PRICE
    {
      title: "MONTHLY PRICE",
      key: "amountPerMonth",
      dataIndex: "amountPerMonth",
    },
    // NUMBER OF MONTHS
    {
      title: "Number Of Months",
      key: "noOfMonths",
      dataIndex: "noOfMonths",
      sorter: (a, b) => a.noOfMonths - b.noOfMonths,
    },
    // DISCOUNT PERCENTAGE
    {
      title: "Discount percentage",
      key: "discount",
      dataIndex: "discount",
    },
    // DISPLAY STATUS
    {
      title: "Display Status",
      key: "displayStatus",
      render: (_, record) => {
        if (record.showInApp && !record.forCodes) return "For Apps";
        if (record.forCodes && !record.showInApp) return "For Codes";
        if (record.showInApp && record.forCodes) return "In Both";
        return "Pending"; // Handle cases where both or neither are true.
      },
      filters: [
        { text: "For Apps", value: "For Apps" },
        { text: "For Codes", value: "For Codes" },
        { text: "In Both", value: "In Both" },
        { text: "Pending", value: "Pending" },
      ],
      onFilter: (value, record) => {
        if (record.showInApp && !record.forCodes) return value === "For Apps";
        if (record.forCodes && !record.showInApp) return value === "For Codes";
        if (record.showInApp && record.forCodes) return value === "In Both";
        return "Pending" === value; // Handle cases where both or neither are true.
      },
    },
    // STATUS
    {
      title: "STATUS",
      key: "status",
      dataIndex: "status",
      render: (_, record) => {
        return (
          <Space size={10}>
            <Switch
              disabled={!(isCeo || isCodesManager)}
              style={{
                backgroundColor: `${
                  record?.isActive ? "rgb(49, 170, 74)" : "gray"
                }`,
                minWidth: "35px",
              }}
              checked={record?.isActive}
              // onChange={() => () => showDeleteModal(record)}
              onClick={() => showDeleteModal(record)}
            />
            <span>{record?.isActive ? "Active" : "Inactive"}</span>
          </Space>
        );
      },
      filters: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      onFilter: (value, record) => record?.isActive === value,
    },
  ];

  const specialColumn = [
    // ACTIONS
    {
      title: "ACTIONS",
      key: "actions",
      render: (_, record) => {
        return (
          <Space size={10} textAlign="center">
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={() => {
                setSelectedPackage(record);
                setAddModalVisible(true);
              }}
            >
              <EditOutlined style={{ color: "#356ab3" }} />
            </button>
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={() => {
                // handleDeletePackage(record);
                setDeletePackageModal(true);
                setSelectedPackage(record);
              }}
            >
              <DeleteOutlined style={{ color: "#f00" }} />
            </button>
          </Space>
        );
      },
    },
  ];

  const columns =
    isCeo || isCodesManager ? [...baseColumns, ...specialColumn] : baseColumns;

  const handleEditPackageStatus = () => {
    setLoadingEditModal(true);
    if (selectedRowData) {
      changePackageStatus(
        { id: selectedRowData?.id, isActive: !selectedRowData?.isActive },
        (success) => {
          if (success?.isSuccess) {
            toastSuccess(success.message);
            setDeleteModalVisible(false);
            setLoadingEditModal(false);
            setRenderMe((prev) => !prev);
          } else {
            toastError(success.err_msg);
            setLoadingEditModal(false);
          }
        },
        (fail) => {
          if (fail?.data) {
            toastError(fail.data?.err_msg);
            setLoadingEditModal(false);
          } else {
            toastError();
            setLoadingEditModal(false);
          }
        }
      );
    }
  };

  const handleDeletePackage = () => {
    setLoadingEditModal(true);
    deletePackage(
      selectedPackage?.id,
      (success) => {
        toastSuccess(success.message);
        setLoadingEditModal(false);
        setDeletePackageModal(false);
        setRenderMe((prev) => !prev);
      },
      (error) => {
        console.log(error);
        toastError(error?.data?.message || "An error occurred");
        setLoadingEditModal(false);
        setDeletePackageModal(false);
      }
    );
  };

  return (
    <section className="users ">
      <div className="users__all-contents ">
        {/* <SideBar /> */}
        <div className="users__content">
          {/* <Navbar /> */}
          {/* <Container className=""> */}
          <div className="users__usersData">
            <Header
              title="Subscriptions"
              plusButtonName="Create"
              plusButtonAction={handleAddEditPackage}
              // disableMe={isCeo ? false : isCodesManager ? false : true}
              disableMe={!(isCeo || isCodesManager)}
            />
            <div className="cast-data__table  grid-table ">
              <Table
                rowKey={(row) => row?.id}
                className=""
                columns={columns}
                dataSource={dataSource}
                rowClassName={(record, index) =>
                  index % 2 === 0 && "background-even-records "
                }
                scroll={{ x: 600 }}
                loadingTable={loadingTable}
              />
            </div>
          </div>
          {/* </Container> */}
        </div>
      </div>
      <AddEditPackageModal
        ref={modalRef}
        selectedPackage={selectedPackage}
        addModalVisible={addModalVisible}
        SubHeader={
          <SubHeader
            bgColor="#F58234"
            title="Create Package"
            closeButton
            onCancel={() => {
              modalRef.current.handleOnCancel();
            }}
          />
        }
        onCancel={onCancel}
        primaryBtnName={!!selectedPackage ? "Save changes" : "Add"}
        secondaryBtnName={!!selectedPackage ? "Discard" : "Cancel"}
      />
      <DeleteModal
        deleteModalVisible={deleteModalVisible}
        loading={loadingEditModal}
        SubHeader={
          <SubHeader
            bgColor="#F58234"
            title="Edit Package Status"
            closeButton
            onCancel={onCancel}
          />
        }
        icon={warrningIcon}
        msg={`Are you sure you want to ${
          selectedRowData?.isActive ? "deactivate" : "activate"
        } this package? `}
        onCancel={onCancel}
        action={handleEditPackageStatus}
        secondaryBtnName="Cancel"
        primaryBtnName={`${
          selectedRowData?.isActive ? "Deactivate" : "Activate"
        }`}
      />
      <DeletePackageModal
        open={deletePackageModal}
        SubHeader={
          <SubHeader
            bgColor="#F58234"
            title="Delete Package"
            closeButton
            onCancel={onCancel}
          />
        }
        onCancel={handleCancelDeletePackageModal}
        action={handleDeletePackage}
        loading={loadingEditModal}
      />
    </section>
  );
};

export default Subscriptions;
